import { render, staticRenderFns } from "./BeeMultiSelect.vue?vue&type=template&id=621a9fa3"
import script from "./BeeMultiSelect.vue?vue&type=script&lang=js"
export * from "./BeeMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports